export const supportedImageTypes = [
    "image/jpeg",
    "image/png",
    "image/bmp",
];

export const isImageSupported = (file: File): boolean => {
    return supportedImageTypes.includes(file.type);
};
